/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import ButtonLink from '../ButtonLink';
import ButtonStep from '../ButtonStep';
import './styles.css';

const ContentButtons = ({ type, data, onClick, color }) => {
  const onClickReturnCallback = (value) => {
    onClick(value);
    document.getElementById('content-buttons').remove();
  };

  return (
    <div id="content-buttons" className="content-buttons">
      {type === 'button' &&
        data.suggestedActions.map((response) => (
          <ButtonStep
            key={response.value}
            color={color}
            onClick={() => onClickReturnCallback(response.value)}
            name={response.title}
          />
        ))}

      {type === 'link' && (
        <ButtonLink
          url={data.suggestedActions[0].value}
          name={data.suggestedActions[0].title}
        />
      )}
    </div>
  );
};

ContentButtons.propTypes = {
  type: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  color: PropTypes.object.isRequired,
};

export default ContentButtons;
